import { isNetworkFailure } from '../lib/network_failure.js'

function showConnectionFailedFlash() {
  const template = document.getElementById('connection-failed-flash')

  if (template && !document.getElementById('connection-failed-alert')) {
    template.after(template.content.cloneNode(true))
  }
}

document.addEventListener('turbo:fetch-request-error', (event) => {
  const isFormOrFrameRequest = event.target.matches?.('form, turbo-frame')

  if (isFormOrFrameRequest && isNetworkFailure(event.detail.error)) {
    showConnectionFailedFlash()
  }
})
